import { CustomerOrgCompany } from "../../common/types/apiTypes";
import { AutocompleteType } from "../../common/types/autoComplete";
import { NameIdOption } from "../../common/types/commonTypes";
import { Nullable } from "../../common/types/nullable";
import { EezyCompany } from "../invoices/invoiceAPI";
import { EntriesGroupAndSortKey } from "./constants";
import { Entry } from "./entriesAPI";

export type GroupKey =
  | EntriesGroupAndSortKey.CustomerOrg
  | EntriesGroupAndSortKey.Talent
  | EntriesGroupAndSortKey.Time
  | EntriesGroupAndSortKey.CustomerCC
  | EntriesGroupAndSortKey.WorkLocation;

export type Approval =
  | "New"
  | "Approved"
  | "CustomerRejected"
  | "Rejected"
  | "";

export type CustomerOrg = { id: string; name: string };
export type CustomerCompany = { id: string; name: string };

export interface CustomerOptions {
  organizations: CustomerOrgCompany[];
  companies: CustomerOrgCompany[];
}

export type SelectedFilters = {
  rangeStart: Date | null;
  rangeEnd: Date | null;
  status: string;
  paymentPeriod: { id: string; name: string } | null;
  customerOrg: CustomerOrg | null;
  customerCompany: CustomerCompany | null;
  eezyCompany: EezyCompany | null;
  isOnInvoice: string;
  isOnPayslip: string;
  approval: Approval;
  isZeroExpenseEntry: string;
  tesId: string;
  hasComment: string;
  workLocations: AutocompleteType[];
  hrRepresentatives: NameIdOption[];
  salaryTypes: AutocompleteType[];
};

export type GroupOption = {
  value: string;
  label: string;
};

export type Filter = {
  name: string;
  value: any;
};

export type CollabsibleStates = {
  supplementsOpen: boolean;
  expensesOpen: boolean;
};

export interface Refs<T> {
  readonly current: T | null;
}

export interface GroupedData {
  [propertyValue: string]: GroupedData | { items: Entry[] };
}

export interface NewEntryBasic {
  startDate: Nullable<Date>;
  assignmentId: string;
}

export enum HistoryType {
  FieldChanges = "fieldChanges",
  ApprovalChanges = "approvalChanges",
}

export interface ParsedEntryChange {
  timestamp: number;
  userId: string;
  userFirstName: string;
  userLastName: string;
  userType: string;
  fields: FieldChange[];
}

export interface FieldChange {
  field: string;
  displayName: string;
  previousValue: string;
  newValue: string;
}

export interface ParsedApprovalChange {
  timestamp: number;
  userId: string;
  userFirstName: string;
  userLastName: string;
  userType: string;
  approvalState: string;
  comment?: string;
}
